import React from 'react';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { AlignedInfo, AppContent, ExternalLink } from '@common/components';
import { SUPPLIER_ADMIN_MENU } from 'works/legacy/pages/supplier/admin-settings/supplier-admin-vertical-nav-menu';
import { Divider, Typography } from 'antd';
import { humanizeTimezone } from 'works/legacy/lib/date-helper';
import { formatPhone } from 'works/legacy/services/phone-service';
import { useCurrentEntity } from '@identity/hooks';

const { Title } = Typography;

export const AdminSupplierDetailsPage = () => {
  useSetBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/supplier/admin',
    },
    {
      name: SUPPLIER_ADMIN_MENU.DETAILS.LABEL,
      path: SUPPLIER_ADMIN_MENU.DETAILS.ROUTE,
    },
  ]);

  const supplier = useCurrentEntity();

  if (supplier) {
    const formattedDefaultContact = supplier?.defaultContact?.name ?? 'N/A';
    const formattedWebsite = supplier?.website ? (
      <ExternalLink url={supplier?.website} />
    ) : (
      'N/A'
    );
    const formattedPhoneNumber =
      (supplier?.phoneNumber && formatPhone(supplier?.phoneNumber)) || 'N/A';
    const formattedAddress = supplier?.address
      ? `${supplier?.address}, ${supplier?.city}, ${supplier?.stateCode} - ${supplier?.postalCode}`
      : 'N/A';

    return (
      <>
        <AppContent className="admin-supplier-details-page">
          <div className="supplier-details-title">
            <Title level={3} style={{ marginRight: '12px' }}>
              {supplier?.name}
            </Title>
          </div>
          <AlignedInfo
            content={[
              ['Default Contact', formattedDefaultContact],
              ['Website', formattedWebsite],
              ['Phone Number', formattedPhoneNumber],
            ]}
          />
          <Divider />
          <AlignedInfo
            content={[
              ['Address', formattedAddress],
              ['Time Zone', humanizeTimezone(supplier.defaultTimeZone)],
            ]}
          />
          <style jsx>{`
            .supplier-details-title {
              margin-bottom: 24px;
              display: flex;
            }
          `}</style>
        </AppContent>
      </>
    );
  }
};
